<template>
  <div>
    <div class="panel-title">
      {{resultsLength}} results found for "<b>{{searchMessage.toUpperCase()}}</b>"
    </div>
    <table class="table table-striped bank-accounts table-fundings" id="results">
      <thead>
        <tr>
          <th>Note number</th>
          <th>CUSIP number</th>
          <th>Account number</th>
          <th>Account name</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <template v-if="hasNotes">
          <tr v-for="(note, index) in notes" :key="`${index}-note-${note.noteId}`">
            <td>{{note.noteId}}</td>
            <td>{{note.cusip}}</td>
            <td>{{account.accountId}}</td>
            <td>{{account.accountName}}</td>
            <td>
              <button type="button" class="btn btn-details btn-outline" v-on:click="goToAccountDetail(account)">Account details</button>
              <button type="button" class="btn btn-details btn-outline" v-on:click="goToNoteDetails(note)">Note details</button>
            </td>
          </tr>
        </template>
        <template v-else>
          <tr>
            <td>---</td>
            <td>---</td>
            <td>{{account.accountId}}</td>
            <td>{{account.accountName}}</td>
            <td>
              <button type="button" class="btn btn-details btn-outline" v-on:click="goToAccountDetail(account)">Account details</button>
              <button disabled type="button" class="btn btn-details btn-outline">Note details</button>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { getAccounTypeProperties } from '@/util';

export default {
  name: 'SearchByAccountResults',
  data() {
    return {};
  },
  props: {
    results: {
      type: Object,
      required: true,
      default: {},
    },
    searchMessage: {
      type: String,
      required: true,
      default: '',
    },
  },
  computed: {
    account() {
      return this.results.account;
    },
    hasNotes() {
      if (this.account) {
        return this.account.notes.length > 0;
      }
      return false;
    },
    resultsLength() {
      if (this.account) {
        return this.hasNotes ? this.account.notes.length : 1;
      }
      return 0;
    },
    user() {
      return this.account.primaryInvestor;
    },
    userId() {
      return this.user ? this.user.id : 0;
    },
    userName() {
      return this.user ? this.user.firstName : '';
    },
    userType() {
      return this.user ? this.user.userType : '';
    },
    notes() {
      return this.account.notes;
    },
  },
  methods: {
    ...mapActions('user', [
      'storeUserInSessionStorage',
    ]),
    getAccountComponentAndAccountId(account) {
      const accountTypeProperties = getAccounTypeProperties(
        account.accountType,
      );
      return {
        component: accountTypeProperties.component,
        accountId: account.id,
        accountName: account.accountName,
      };
    },
    goToNoteDetails(note) {
      const routeParams = {
        name: 'NoteDetail',
        params: {
          noteId: note.id,
          userId: this.userId,
          name: this.userName,
        },
      };

      this.$router.push(routeParams);
    },
    goToAccountDetail(account) {
      const {
        component,
        accountId,
      } = this.getAccountComponentAndAccountId(account);

      const routeParams = {
        name: component,
        params: {
          accountId,
          name: this.userName,
          userId: this.userId,
        },
      };

      this.$router.push(routeParams);
    },
  },
};
</script>

<style scoped>
  .btn-details {
    margin-right: 15px;
  }
</style>



// WEBPACK FOOTER //
// SearchByAccountResults.vue?322ac927